export const OtherMenu5 = () => {
  return (
    <span>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        className="base"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.3"
          d="M5.5 9.5C5.70679 8.8294 6.07721 8.19931 6.64526 7.63611C7.09251 7.19268 7.55668 6.90025 8.0224 6.72327M13.6007 4.14593C15.2743 3.08425 17.9773 2.08032 20.3115 4.46071C25.8525 10.1114 16.3502 21 12 21C7.64988 21 -1.85249 10.1114 3.68853 4.46072C6.02272 2.08035 8.72564 3.08427 10.3993 4.14593C11.345 4.74582 12.655 4.74582 13.6007 4.14593Z"
          stroke="#1A1A1A"
          strokeWidth="2"
          strokeLinecap="round"
        />
      </svg>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        className="active-icon"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.5 9.5C5.70679 8.8294 6.07721 8.19931 6.64526 7.63611C7.09251 7.19268 7.55668 6.90025 8.0224 6.72327M13.6007 4.14593C15.2743 3.08425 17.9773 2.08032 20.3115 4.46071C25.8525 10.1114 16.3502 21 12 21C7.64988 21 -1.85249 10.1114 3.68853 4.46072C6.02272 2.08035 8.72564 3.08427 10.3993 4.14593C11.345 4.74582 12.655 4.74582 13.6007 4.14593Z"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
        />
      </svg>
    </span>
  );
};
